import PropTypes from "prop-types";
import { forwardRef } from "react";
// components
import TextField from "src/components/template/text-field";
//
import { SELECT } from "src/config-global";

// ----------------------------------------------------------------------

const XSelect = forwardRef(({
                                children,
                                placeholder,
                                native = false,
                                maxHeight = 220,
                                sx,
                                SelectProps,
                                MenuProps,
                                PaperProps,
                                InputProps,
                                ...other
                            }, ref) => (
    <TextField
        ref={ ref } select

        { ...other }

        InputProps={ {
            sx: {
                borderRadius: `${ SELECT.BASE_RADIUS }px`
            },
            ...InputProps
        } }

        SelectProps={ {
            ...SelectProps,

            native,
            MenuProps: {
                ...MenuProps,

                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                PaperProps: {
                    ...PaperProps,

                    sx: {
                        maxWidth: `${ SELECT.MENU_MAX_WIDTH }`,
                        ...( !native && {
                            maxHeight: typeof maxHeight === "number" ? maxHeight : "unset"
                        } ),
                        py: `${ SELECT.PADDING_Y }px`,
                        px: `${ SELECT.PADDING_X }px`,
                        borderRadius: `${ SELECT.BASE_RADIUS }px`,

                        textTransform: "capitalize",

                        ...PaperProps?.sx
                    }
                }
            }
        } }

        sx={ {
            minWidth: `${ SELECT.MIN_WIDTH }px`,
            maxWidth: {
                md: `${ SELECT.MAX_WIDTH }px`
            },

            "&.MuiFormControl-fullWidth": {
                maxWidth: "unset"
            },

            "& .MuiFormHelperText-root": {
                textTransform: "none"
            },

            textTransform: "capitalize",

            ...sx
        } }
    >
        { children }
    </TextField>
));

XSelect.propTypes = {
    children: PropTypes.node,
    maxHeight: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
    placeholder: PropTypes.string,
    native: PropTypes.bool,
    SelectProps: PropTypes.object,
    MenuProps: PropTypes.object,
    PaperProps: PropTypes.object,
    InputProps: PropTypes.object,
    sx: PropTypes.object
};

export default XSelect;
